import styles from '../styles/BasicFormSelect.module.css';
export default function BasicFormSelect({
  label,
  updateKey,
  value,
  onChange,
  className,
  disabled = false,
  displayEmpty = false,
  options = []
}) {
  return (
    <div className={styles.inputContainer}>
      <label htmlFor={`${updateKey}-input`} className={styles.label}>
        {label}
      </label>
      <select
        disabled={disabled}
        required={label[0] === '*'}
        name={`${updateKey}`}
        onChange={onChange}
        id={`${updateKey}-input`}
        value={value}
        className={`${styles.input} ${className}`}
      >
        {displayEmpty && <option value='' style={{ display: 'none' }} />}
        {options.length > 0 &&
          options.map((option, idx) => (
            <option value={option.value} className={styles.option} key={idx}>
              {option.label}
            </option>
          ))}
      </select>
    </div>
  );
}
